<template>
    <div v-if="show" class="modal-wrapper">
        <form class="modal" @submit.prevent="activate" :disabled="!valid">
            <h3>💪 Drip Funnels Premium</h3>
            <div class="modal-content">
                <div class="notice">
                    <p v-if="feature">
                        To <strong>{{feature}}</strong>, you need to upgrade.
                    </p>
                    <p v-if="app.subscription && app.subscription.active">
                        You have already entered a valid Activation Key!
                    </p>
                    <p v-else-if="app.subscription">
                        Need to purchase an activation key? <a href="https://www.drip-funnels.com/pricing/" target="_blank" class="link">Click here</a>.
                    </p>
                    <p v-else>
                        <a href="https://www.drip-funnels.com/try/" target="_blank" class="link">Try FREE for 14 Days</a> or <a href="https://www.drip-funnels.com/pricing/" target="_blank" class="link">Purchase an Activation Key</a>.
                    </p>
                </div>
                <div class="field">
                    <label>What is your activation key?</label>
                    <input type="text" v-model="key">
                </div>
            </div>
            <div class="modal-actions">
                <a @click="reset" href="javascript:;" class="cancel">Cancel</a>
                <button :disabled="!valid">
                    <template v-if="valid">
                        Activate <em>Now</em>
                    </template>
                    <template v-else>
                        Invalid Activation Key
                    </template>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import validateKey from '../app/validate-key';

export default {
    props: ['app'],
    data() {
        var _ = this;

        return {
            show: false,
            key: '',
            feature: ''
        };
    },
    computed: {
        valid() {
            var _ = this,
                validation = validateKey(_.key);

            return validation && validation.active;
        }
    },
    methods: {
        reset() {
            var _ = this;

            _.show = false;
            _.key = '';
        },

        activate() {
            var _ = this,
                oldSetting = _.app.getSetting('activation'),
                setting = {
                    name: 'activation',
                    value: _.key
                };

            if (oldSetting) {
                setting.id = oldSetting.id;
            }

            _.app.requester.request({
                controller: 'settings',
                action: 'save',
                setting: setting
            }, function(err, data) {
                if (data && data.settings[0]) {
                    _.app.setSubscription(_.key);
                }

                _.reset();
            });
        }
    }
};
</script>
